import React, { Component } from "react";
import { dateToHHMM, getFlightsList, getPassengerList } from "../../../shared/utils";
import BaseAlert from "./base-components/BaseAlert";

export default class CancellationInfoModal extends Component {
	constructor(props) {
		super(props);
		this.passengers = getPassengerList(this.props.passengers);
		this.flights = getFlightsList(this.props.flights);

		this.state = {
			passengers: this.passengers,
			flights: this.flights,
			allPassengersSelected: false,
			allFlightsSelected: false,
			message: false,
			formInfo: {
				passengers: [],
				flights: []
			},
			typeCancel: "partialCancel"
		};

		this.submitConfirmation = this.submitConfirmation.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleAllPassengersChecked = event => {
		let passengers = this.state.passengers;
		let allPassengersSelected = !this.state.allPassengersSelected;
		passengers.forEach(passenger => (passenger.isChecked = allPassengersSelected));
		this.setState({
			passengers: passengers,
			allPassengersSelected: allPassengersSelected
		});
		let formInfo = this.state.formInfo;
		formInfo.passengers = [];
		if (allPassengersSelected) {
			passengers.forEach(passenger => formInfo.passengers.push(passenger.idpassengers));
		}
	};

	handleCheckPassengerElement = event => {
		let passengers = this.state.passengers;
		let allPassengersSelected = true;
		passengers.forEach(passenger => {
			if (passenger.idpassengers === event.target.value) passenger.isChecked = !passenger.isChecked;
			if (!passenger.isChecked) allPassengersSelected = false;
		});
		this.setState({
			passengers: passengers,
			allPassengersSelected: allPassengersSelected
		});
		this.handleChange(event);
	};

	handleAllFlightsChecked = event => {
		let flights = this.state.flights;
		let allFlightsSelected = !this.state.allFlightsSelected;
		flights.forEach(flight => (flight.isChecked = allFlightsSelected));
		this.setState({
			flights: flights,
			allFlightsSelected: allFlightsSelected
		});
		let formInfo = this.state.formInfo;
		formInfo.flights = [];
		if (allFlightsSelected) {
			flights.forEach(flight => formInfo.flights.push(flight.stretch));
		}
	};

	handleCheckFlightElement = event => {
		let flights = this.state.flights;
		let allFlightsSelected = true;
		flights.forEach(flight => {
			if (flight.stretch === event.target.value) {
				flight.isChecked = !flight.isChecked;
			}
			if (!flight.isChecked) allFlightsSelected = false;
		});
		this.setState({
			flights: flights,
			allFlightsSelected: allFlightsSelected
		});
		this.handleChange(event);
	};

	setAlertMessage (message) {
		this.setState({ message: message });		
	}

	validateCancel() {
		let formInfo = this.state.formInfo;
		if (!formInfo.passengers.length) {
			this.setAlertMessage("Você precisa selecionar um passageiro ou mais para continuar.");
			return false;
		} else if (!formInfo.flights.length) {
			this.setAlertMessage("Você precisa selecionar um trecho ou mais para continuar.");
			return false;
		}
		return true;
	}

	checkIsValidForTotalCancel() {
		let formInfo = this.state.formInfo;
		let typeCancel = "partialCancel";
		if (
			formInfo.flights.length === this.state.flights.length &&
			formInfo.passengers.length === this.state.passengers.length
		) {
			if (!this.props.enableTotalCancel) {
				this.setAlertMessage("Você não pode solicitar o orçamento de cancelamento total. Os valores para cancelamento total já estão representados na tela de detalhes de cancelamento.");
				return false;
			}
			typeCancel = "totalCancel";
		}

		this.setState({
			typeCancel: typeCancel
		});
		return true;
	}

	submitConfirmation(event) {
		event.preventDefault();
		let formInfo = this.state.formInfo;
		const typeCancel = this.state.typeCancel;
		if (this.validateCancel() && this.checkIsValidForTotalCancel()) {
			formInfo.typeCancel = typeCancel;
			formInfo.budget = true;
			this.props.callback(formInfo);
		}
	}

	handleChange(event) {
		let formInfo = this.state.formInfo;
		let field = event.target.name.replace(/\[/g, "").replace(/\]/g, "");
		let value = event.target.value;

		for (var i = 0; i < formInfo[field].length; i++) {
			if (
				formInfo[field][i] == event.target.value ||
				formInfo[field][i].name == event.target.value
			) {
				formInfo[field].splice(i, 1);
			}
		}
		if (event.target.checked) {
			formInfo[field].push(value);
		}		
		this.checkIsValidForTotalCancel();
		this.setState({ formInfo: formInfo });
	}

	render() {
		return (
			<div
				className={`cancellation-modal tingle-modal ${
					this.props.open ? "tingle-modal--visible" : ""
				}`}
			>
				<div className="tingle-modal-box cancellation-modal-box" data-type={this.props.type}>
					<form onSubmit={this.submitConfirmation}>
						<div className="modal-header-wrapper">
							<button
								onClick={() => this.props.closeModal()}
								type="button"
								className="close-button"
								alt="Fechar"
							>
								<i className="icon-close" />
							</button>

							<p className="lead">Solicitar orçamento para cancelar seu voo</p>
							<p>
								Você iniciou a solicitação para cancelamento da sua viagem e, agora, vamos elaborar
								seu orçamento. Antes da gente prosseguir, selecione abaixo quais passageiros e
								trechos você deseja cancelar.
							</p>
							<div>
								<BaseAlert
									visible={!!this.state.message}
									type="danger"
									>
									<p>{this.state.message}</p>
								</BaseAlert>
							</div>
							<div className="row init-margin">
								<div className="col-xs-16">
									<p className="text-left">
										<strong className="text-left">
											Quais passageiros você deseja inserir nessa solicitação?
										</strong>
										<a className="pull-right a-link" onClick={this.handleAllPassengersChecked} data-action={`my-trips-select-passengers-${!this.state.allPassengersSelected ? "todos" : "nenhum"}`}>
											<small className="text-bottom">
												Selecionar {!this.state.allPassengersSelected ? "todos" : "nenhum"}
											</small>
										</a>
									</p>
								</div>
								{this.state.passengers.map((passenger, key) => (
									<div key={key}>
										<div className="passengers-check">
											<input
												type="checkbox"
												name={"passengers[]"}
												id={"passenger-" + passenger.idpassengers}
												className="styled-checkbox"
												value={passenger.idpassengers}
												checked={!!passenger.isChecked}
												onChange={this.handleCheckPassengerElement}
												data-action="my-trips-select-passenger"
											/>
											<label htmlFor={"passenger-" + passenger.idpassengers} className="no-margin" data-action="my-trips-select-passenger">
												{passenger.name}
											</label>
										</div>
									</div>
								))}
							</div>

							<div className="row init-margin">
								<div className="col-xs-16">
									<p className="text-left">
										<strong className="text-left">
											Quais trechos você deseja inserir nessa solicitação?
										</strong>
										<a className="pull-right a-link" onClick={this.handleAllFlightsChecked} data-action={`my-trips-select-flights-${!this.state.allFlightsSelected ? "todos" : "nenhum"}`}>
											<small className="text-bottom">
												Selecionar {!this.state.allFlightsSelected ? "todos" : "nenhum"}
											</small>
										</a>
									</p>
								</div>
								<div className="col-xs-16">
									<div className="cancellation-flight-wrapper">
										{this.state.flights.map((flight, key) => (
											<div className="flight-cancell-resume" key={key}>
												<div className="label-well text-left">{flight.title}</div>
												<div className="flight-stretch-line no-padding" key={flight.id}>
													<div className="flight-airline-info">
														<span className="flight-airline-name">
															<i className={`icon icon-${flight.stretch}`} /> {flight.airline}
														</span>
														<span className="flight-airline-number small">
															({flight.flightNumber})
														</span>
													</div>

													<div className="flight-airline-stretchs-info">
														<div className="flight-airline-check">
															<input
																type="checkbox"
																name={"flights[]"}
																id={"flight-" + flight.flightNumber}
																className="styled-checkbox"
																value={flight.stretch}
																checked={!!flight.isChecked}
																onChange={this.handleCheckFlightElement}
															/>
															<label
																data-action={`my-trips-select-trip-${flight.title}`}
																htmlFor={"flight-" + flight.flightNumber}
																className="no-margin"
															/>
														</div>
														<div className="flight-departure">
															<span className="small-title hidden">Partida:</span>
															<span className="flight-stretch-airport">
																{dateToHHMM(flight.departureDate)} <span className="iata">{flight.from}</span>
															</span>
															{flight.departureDate.substr(0, 10)}
														</div>
														<i className="icon icon-arrow" />
														<div className="flight-arrival">
															<span className="small-title hidden">Chegada:</span>
															<span className="flight-stretch-airport">
																{flight.to} <span className="iata">{dateToHHMM(flight.arrivalDate)}</span>
															</span>
															{flight.arrivalDate.substr(0, 10)}
														</div>
													</div>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
						<div className="tingle-modal-box__content no-padding">
							<div className="row init-margin">
								<div className="col-xs-16 col-md-16">
									<button
										type="submit"
										name="submit_cancellation_info_data"
										id="submit_cancellation_info_data"
										className="btn btn-success btn-go no-margin-vertical"
									>
										OK
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}
}
